module.exports = __webpack_public_path__ + "static/media/malex-medic.1fce0e44.png";